import { SuperuserSkillEditorPage } from "@/features/superuser/skills/superuser-skill-editor.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/skills/new")({
  component: SuperuserSkillEditorPage,
});
